import { useEffect, useMemo, useRef } from "react";

import { useGetJobsQuery } from "@js/apps/jobs/api";
import { Snackbar } from "@js/components/snackbar";
import { useResetQueryExceptUTM } from "@js/hooks/use-reset-query-except-utm";
import type { JobSubType } from "@js/types/jobs";

import { useProcessedPublicJobsFilters } from "../use-processed-public-jobs-filters";

export type UsePublicJobsListingArg = {
  defaultFilters?: { sub_type?: JobSubType };
};

export const usePublicJobsListing = ({
  defaultFilters,
}: UsePublicJobsListingArg) => {
  const { resetQueryExceptUTM } = useResetQueryExceptUTM();
  const { filters, isAnyFilterApplied } = useProcessedPublicJobsFilters();
  const filtersWithDefaults = useMemo(() => {
    return { ...filters, ...defaultFilters };
  }, [filters, defaultFilters]);

  const {
    data: jobsData,
    isLoading,
    error,
  } = useGetJobsQuery(filtersWithDefaults);

  const handleError = () => {
    Snackbar.error("Wrong filter value provided, failed to fetch jobs");
    resetQueryExceptUTM();
  };
  const handleErrorRef = useRef(handleError);

  useEffect(() => {
    if (!error) {
      return;
    }

    handleErrorRef.current();
  }, [error, handleErrorRef]);

  return {
    jobs: jobsData?.results || [],
    total: jobsData?.count || 0,
    openingsCount: jobsData?.total_openings_count || 0,
    loading: isLoading,
    isAnyFilterApplied,
  };
};
